export const GLOBAL_EXPERIENCE_PAGE_TYPE = {
  ATTRACTIONS: 'Attractions',
  RIDES: 'Rides',
  TICKETS: 'Tickets',
};
